module.exports = __webpack_public_path__ + "static/media/banner-ca-cc.191edca6.jpg";